import { render, staticRenderFns } from "./JiraImportProblemsListDialog.vue?vue&type=template&id=51459c5e"
import script from "./JiraImportProblemsListDialog.vue?vue&type=script&lang=js"
export * from "./JiraImportProblemsListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports